import { CLOSE_TEST_MODAL, ON_ENTER_TEST_ROOM, ON_REFETCH_TEST_LIST, ON_TEST_SUBMITTED, SET_ANSWER_LIST, SET_FOCUS_TEST_ID, SET_FOCUS_USER, SET_NOT_SUBMIT_USER, SET_OMR_FREQUENCY, SET_PERSONAL_TIMER_STARTED, SET_TEST_TIME_UP, SET_QUESTION_LIST, SET_STATISCIS_LIST, SET_SUBMIT_LIST, SET_SURVEY_FREQUENCY, SET_SURVEY_SAVE, SET_TEST_BACKGROUND, SET_TEST_LIST, TOGGLE_FOLD_MODAL, TOGGLE_TEST_MODAL } from './actionTypes';
export const onEnterTestRoom = () => {
    return {
        type: ON_ENTER_TEST_ROOM,
    };
};
/**
 * 테스트 목록 전체 재조회.
 * @param showLoad 전체화면 로딩 표시 여부 — 사용자가 직접 트리거한 흐름(본인 제출 등)만 true.
 *   WS 브로드캐스트 발 백그라운드 갱신은 false(기본) — 남의 제출/시작 신호마다 방 전원에게
 *   전체화면 로딩이 뜨던 문제 방지.
 */
export const onRefetchTestList = (showLoad = false, retryUnsubmitted = false, retryTestId) => {
    return {
        type: ON_REFETCH_TEST_LIST,
        showLoad,
        retryUnsubmitted,
        retryTestId,
    };
};
/**
 * 누군가의 제출 신호(WS MIMAC.Test.Submitted) — 전원 전체 재조회 대신 역할별 최소 처리
 */
export const onTestSubmitted = (payload) => {
    return {
        type: ON_TEST_SUBMITTED,
        payload,
    };
};
export const setTestNoticeMessage = (message) => {
    return {
        type: 'SET_TEST_NOTICE_MESSAGE',
        message,
    };
};
export const setIsEnterRoom = (isEnterRoom) => {
    return {
        type: 'SET_IS_ENTER_ROOM',
        isEnterRoom,
    };
};
export const setIsMockMode = (isMockMode) => {
    return {
        type: 'SET_IS_MOCK_MODE',
        isMockMode,
    };
};
export const setTestBackground = (backgroundUrl) => {
    return {
        type: SET_TEST_BACKGROUND,
        backgroundUrl,
    };
};
export const setTestList = (items) => {
    return {
        type: SET_TEST_LIST,
        items,
    };
};
export const setStatisticsList = (test_id, statisticsList) => {
    return {
        type: SET_STATISCIS_LIST,
        testId: test_id,
        statisticsList,
    };
};
export const setSubmitList = (test_id, submitStatus) => {
    return {
        type: SET_SUBMIT_LIST,
        testId: test_id,
        submitStatus,
    };
};
export const setQuestionList = (test_id, questionList) => {
    return {
        type: SET_QUESTION_LIST,
        testId: test_id,
        questionList,
    };
};
export const setAnswerList = (answerList) => {
    return {
        type: SET_ANSWER_LIST,
        answerList,
    };
};
export const setNotSubmitUser = (submitted) => {
    return {
        type: SET_NOT_SUBMIT_USER,
        submitted,
    };
};
export const closeTestModal = () => {
    return {
        type: CLOSE_TEST_MODAL,
    };
};
export const toggleTestModal = (isModal) => {
    return {
        type: TOGGLE_TEST_MODAL,
        isModal,
    };
};
export const toggleTestFold = (isModal) => {
    return {
        type: TOGGLE_FOLD_MODAL,
        isModal,
    };
};
export const setFocusTestId = (testId) => {
    return {
        type: SET_FOCUS_TEST_ID,
        testId,
    };
};
export const setFocusUser = (userId, userName) => {
    return {
        type: SET_FOCUS_USER,
        user: userId ? { id: userId, name: userName } : undefined,
    };
};
export const setSurveyFrequency = (testId, frequency) => {
    return {
        type: SET_SURVEY_FREQUENCY,
        testId,
        frequency,
    };
};
export const setSurveyTempSave = (testId) => {
    return {
        type: 'SET_SURVEY_TEMP_SAVE',
        testId,
    };
};
export const setSurveySave = (testId, surveySave) => {
    return {
        type: SET_SURVEY_SAVE,
        testId,
        surveySave,
    };
};
export const setOmrFrequency = (testId, frequency) => {
    return {
        type: SET_OMR_FREQUENCY,
        testId,
        frequency,
    };
};
export const setOmrTempSave = (testId) => {
    return {
        type: 'SET_OMR_TEMP_SAVE',
        testId,
    };
};
export const setSubmitOption = (data) => {
    return {
        type: 'SET_SUBMIT_OPTION',
        data,
    };
};
export const setTestType = (testType) => {
    return {
        type: 'SET_TEST_TYPE',
        testType,
    };
};
// 모의고사 개별 타이머: 학생이 실제 문항/첨부파일을 처음 확인한 시점에 호출.
// red_time(OnlyTestMode)·풀이화면 타이머가 같은 redux 신호로 함께 재렌더되도록 한다.
export const setPersonalTimerStarted = (testId) => {
    return {
        type: SET_PERSONAL_TIMER_STARTED,
        testId,
    };
};
// 풀이시간 종료 신호(무제출 포함) — TestMain 등이 리렌더로 반응하도록 redux에 기록.
export const setTestTimeUp = (testId) => {
    return {
        type: SET_TEST_TIME_UP,
        testId,
    };
};
